// extracted by css-extract-rspack-plugin
export default {"crosshair":"crosshair-eLqfh9"};